import { render, staticRenderFns } from "./access.vue?vue&type=template&id=1da8f816&"
import script from "./access.vue?vue&type=script&lang=js&"
export * from "./access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports